import React from 'react';

interface CardProps {
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  title,
  children,
  footer,
  className = '',
  onClick,
}) => {
  return (
    <div className={`bg-white shadow rounded-lg overflow-hidden ${className}`} onClick={onClick}>
      {title && (
        <div className="px-4 py-4 sm:px-6 border-b border-gray-200">
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        </div>
      )}
      <div className="px-4 py-4 sm:p-6 h-full">{children}</div>
      {footer && (
        <div className="px-4 py-4 sm:px-6 bg-gray-50 border-t border-gray-200">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
